import { useIntervalFn, useThrottleFn } from '@vueuse/core'
import { onMounted, onUnmounted } from 'vue'

import { IDLE_LOCK_MS, useAppStore } from '@/stores/app'

const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel'] as const

// Locks the app (logout) after IDLE_LOCK_MS without any interaction. The deadline is
// derived from a timestamp (not a single long setTimeout) so a throttled/sleeping tab
// still locks on time once it wakes up.
export const useIdleLock = () => {
  const appStore = useAppStore()

  let lastActivity = Date.now()

  const markActivity = useThrottleFn(() => {
    lastActivity = Date.now()
    if (appStore.isLoggedIn()) appStore.touchActivity()
  }, 1000)

  const check = () => {
    if (!appStore.isLoggedIn()) {
      lastActivity = Date.now()
      return
    }

    if (Date.now() - lastActivity >= IDLE_LOCK_MS) appStore.setLogout()
  }

  const { pause, resume } = useIntervalFn(check, 5000, { immediate: false })

  onMounted(() => {
    ACTIVITY_EVENTS.forEach((evt) => document.addEventListener(evt, markActivity, { passive: true }))
    resume()
  })

  onUnmounted(() => {
    ACTIVITY_EVENTS.forEach((evt) => document.removeEventListener(evt, markActivity))
    pause()
  })
}
